import { render, staticRenderFns } from "./MonitoringBagRecycling.vue?vue&type=template&id=ebfb04de"
import script from "./MonitoringBagRecycling.vue?vue&type=script&lang=js"
export * from "./MonitoringBagRecycling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebfb04de')) {
      api.createRecord('ebfb04de', component.options)
    } else {
      api.reload('ebfb04de', component.options)
    }
    module.hot.accept("./MonitoringBagRecycling.vue?vue&type=template&id=ebfb04de", function () {
      api.rerender('ebfb04de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/sortingDataMonitoring/components/MonitoringBagRecycling.vue"
export default component.exports